<template>
    <div class="study-item v3_box_teal font_Montserrat">
      <div class="v3_box_teal_header shadow-none py-2">
        <b-row align-v="center" style="justify-content: space-between;">
          <b-col cols="8" sm="11">
            <b-row class="h-100">
              <b-col cols="12" sm="10">
                <div class="h-100 d-flex align-items-center">
                  <h2 class="mb-0 font_size_1250rem">
                    <strong>Job Opportunities - {{ variantName }}</strong>
                  </h2>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col
            cols="4"
            sm="1"
            class="d-flex justify-content-sm-end my-2 my-lg-0"
          >
            <b-button
              class="v3_button_collapse text-decoration-none justify-content-end collapse-button"
              v-b-toggle="`job-offers-info-${$options.name}-${variant}`"
              variant="link"
              style="width: 100px;"
            >
              <span class="when-closed when justify-content-end">
                <span class="bv-d-sm-down-none">Expand</span>
                <i class="mdi mdi-chevron-down" />
              </span>
              <span class="when-opened when justify-content-end">
                <span class="bv-d-sm-down-none">Collapse</span>
                <i class="mdi mdi-chevron-up" />
              </span>
            </b-button>
          </b-col>
        </b-row>
      </div>
      <b-collapse
        :id="`job-offers-info-${$options.name}-${variant}`"
        visible
        class="phairify-card-body v3_box_teal_body"
      >
        <v-wait :for="loaderId" :visible="saveLoading">
          <template slot="waiting">
            <HalfCircleSpinner />
            <div class="spinner-message my-3 text-center">
              Loading...
            </div>
          </template>
          <template>
            <b-card class="border_0 rounded_0">
              <template v-if="!jobOffers || !jobOffers.length">
                You do not have any {{ variantNameInLowerCase }} Job Opportunities.
              </template>
              <template v-else>
                <template v-for="jo in jobOffers">
                  <recruiter-job-offers-history-item
                    :key="jo.id"
                    :job-offer="jo"
                  />
                </template>
              </template>
            </b-card>
          </template>
        </v-wait>
      </b-collapse>
    </div>
  </template>
  
  <script>
  import RecruiterJobOffersHistoryItem from '@/components/recruiter/job_offers/RecruiterJobOffersHistoryItem';
  import { HalfCircleSpinner } from 'epic-spinners';
  import {JOB_OFFER_STATUS_NAMES, JOB_OFFER_STATUSES} from '@/store';
  
  export default {
    name: 'RecruiterJobOffersHistory',
    components: {
        RecruiterJobOffersHistoryItem,
        HalfCircleSpinner
    },
    props: {
      variant: {
        type: String,
        validator: (prop) =>
          [JOB_OFFER_STATUSES.ACTIVE, JOB_OFFER_STATUSES.CLOSED].includes(prop),
        default: JOB_OFFER_STATUSES.ACTIVE,
      },
      jobOffers: {
        validator: (prop) => typeof prop === 'object' || prop === null,
        default: null,
      },
      saveLoading: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      loaderId: function () {
        return `loading_${this.$options.name}`;
      },
      variantName: function () {
        return this.JOB_OFFER_STATUS_NAMES[this.variant];
      },
      variantNameInLowerCase: function () {
        return this.JOB_OFFER_STATUS_NAMES[this.variant].toLowerCase();
      },
      JOB_OFFERS_STATUSES: function () {
        return JOB_OFFER_STATUSES;
      },
      JOB_OFFER_STATUS_NAMES: function () {
        return JOB_OFFER_STATUS_NAMES;
      },
    },
    methods: {
     
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .btn-next{
    display: inline-flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    max-height: 30px;
    font: normal normal 550 16px/24px;
    letter-spacing: 0;
    color: #00586f !important;
    background-color: #b0d27b !important;
    border: 1px solid #00586f !important;
    opacity: 1;
  }
  </style>
  